// IE 2026 10 05 / ODOO-5800 (fe-87; замечание Игоря 05.10 со скрином dev02, отчёт 1fxa_001, режим «Differences only»: в колонке «Type» у полос раскладки
// стоит литерал «tabrow»; харнесс handoff-tools/2026-10-05/diff_filter). Служебные строки отчёта в режимах сравнения с предыдущей моделью:
//  • колонку «Type» бэк привязывает к _DLRow.row_type (data_layout2.compare_row_type_column): там метка под-строки сравнения («≡ prev» / «Δ» / «Δ%»), 'Total'
//    итога и отметка утверждения — но в том же реквизите лежит ВИД строки раскладки ('tab' / 'tabrow' / 'tabcol' / 'tabheader', get_DLRow бэка): технический
//    перечень грид печатал как есть. rowType_label — текст ячейки колонки: вид строки раскладки пользователю не показывается;
//  • IE 2026 10 06 / ODOO-5800 (ревью 05.10): «Differences only» оставляет в дереве грида ТОЛЬКО показанные строки (как до правки — грид, фильтры, итоги под
//    чипсами, счётчик вкладки, экспорт / копирование, вкладки Chart / Styles / Compare неизменённых строк не видят), а неизменённые бэк кладёт целым поддеревом
//    в служебный список _cmp_hidden показанного родителя (compare_diff_filter). Его читает только формула остатка формы ячейки — ей нужны все слагаемые блока
//    объекта: compare_kidsWithHidden — обход подчинённых вместе со спрятанными, compare_hiddenRowsOf — строки, которых нет в дереве грида (на экране не
//    метятся). Первая редакция (05.10) метила такие строки _DLRow.hide и оставляла в дереве — их брали утверждение планов и печать на бэке, итоги групп,
//    фильтр колонки, счётчик вкладки и кнопка раскрытия группы на фронте. Выключатель fe.cellForm.formulaHiddenRows (читает AttrGrid.influence_update);
//  • compare_isSubRow — под-строка сравнения СТРОГО (строка make_row бэка: cssClasses 'row-compare'); полоса и итог 'Total' под-строками не являются
//    (у итога _variant === row_type === 'Total' — cellStory.story_isCompareRow считает его «не листом» для формулы, для навигации это не годится);
//  • compareNav_targetsOf — остановки чипса «Δ vs …»: строка с под-строками сравнения либо со своими отклонениями (_DLRow.cmp_cells). Прежний признак
//    «у ребёнка есть row_type» делал остановкой корень блока с полосами / группу с итогом; спрятанная строка (_DLRow.hide / _ogHide — Option group) остановкой не бывает.
// Выключатель fe.ux.compareServiceRows (читает AttrGrid; false — прежние печать row_type и набор остановок).
export const LAYOUT_ROW_KINDS = ['tab', 'tabrow', 'tabcol', 'tabheader']
export const COMPARE_ROW_TYPE_BINDING = '_DLRow.row_type'

export function rowType_label(value) {
    if (value === null || value === undefined) return ''
    const s = String(value)
    return LAYOUT_ROW_KINDS.includes(s) ? '' : s
}

export function compare_isSubRow(x) {
    if (!x || typeof x !== 'object') return false
    const d = x._DLRow
    if (!d || typeof d !== 'object') return false
    if (Array.isArray(d.cssClasses)) {
        if (d.cssClasses.includes('row-compare')) return true
        if (d.cssClasses.includes('row-totals')) return false
    }
    return !!x._variant && d.row_type === x._variant && d.row_type !== 'Total' && !LAYOUT_ROW_KINDS.includes(String(d.row_type))
}

export function compare_isHiddenRow(x) { return !!(x && typeof x === 'object' && ((x._DLRow && x._DLRow.hide) || x._ogHide)) }

// IE 2026 10 06 / ODOO-5800: служебный список неизменённых подчинённых строки, убранных из дерева отбором «Differences only» (бэк data_layout2.COMPARE_HIDDEN_KEY)
export const COMPARE_HIDDEN_KEY = '_cmp_hidden'   // IE 2026 10 06 / ODOO-5800

// kids — имя поля подчинённых либо функция; возвращает функцию «подчинённые строки вместе со спрятанными отбором» (спрятанных нет — то же, что отдаёт kids)
export function compare_kidsWithHidden(kids = 'attrs') {   // IE 2026 10 06 / ODOO-5800
    const base = typeof kids === 'function' ? kids : (x) => (x ? x[kids] : undefined)
    return (x) => {
        const own = base(x)
        const hid = x && typeof x === 'object' ? x[COMPARE_HIDDEN_KEY] : undefined
        if (!Array.isArray(hid) || !hid.length) return own
        return Array.isArray(own) && own.length ? own.concat(hid) : hid
    }
}

// строки поддерева top, которых нет в дереве грида: всё, что лежит в _cmp_hidden (каждая спрятанная строка со всеми своими потомками)
export function compare_hiddenRowsOf(top, kids = 'attrs') {   // IE 2026 10 06 / ODOO-5800
    const out = new Set()
    const base = typeof kids === 'function' ? kids : (x) => (x ? x[kids] : undefined)
    const walk = (x, hidden) => {
        if (!x || typeof x !== 'object') return
        if (hidden) out.add(x)
        const own = base(x)
        if (Array.isArray(own)) for (const k of own) walk(k, hidden)
        const hid = x[COMPARE_HIDDEN_KEY]
        if (Array.isArray(hid)) for (const k of hid) walk(k, true)
    }
    walk(top, false)
    return out
}

// strict = false — прежний обход грида (до fe-87): остановка — строка, у ребёнка которой есть любой row_type, либо строка с cmp_cells; спрятанные не исключаются
export function compareNav_targetsOf(rows, kids = 'attrs', strict = true) {
    const out = []
    const walk = (list) => {
        for (const n of list || []) {
            if (!n || typeof n !== 'object') continue
            const ch = n[kids]
            if (!strict) {
                if (Array.isArray(ch) && ch.some(k => k?._DLRow?.row_type)) out.push(n)
                else if (n._DLRow?.cmp_cells) out.push(n)
            } else if (!compare_isHiddenRow(n) && !compare_isSubRow(n)) {
                if (Array.isArray(ch) && ch.some(compare_isSubRow)) out.push(n)
                else if (n._DLRow?.cmp_cells) out.push(n)
            }
            if (Array.isArray(ch)) walk(ch)
        }
    }
    walk(rows)
    return out
}
